/* unplugin-vue-components disabled */import { render } from "./MyDepartment.vue?vue&type=template&id=04aa2b0e&scoped=true&ts=true"
import script from "./MyDepartment.vue?vue&type=script&lang=ts"
export * from "./MyDepartment.vue?vue&type=script&lang=ts"

import "./MyDepartment.vue?vue&type=style&index=0&id=04aa2b0e&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04aa2b0e"]])

export default __exports__